import api from '../../api/shadhin'

const state = {
    notifications: [],
    isNotifications: {
        loading     : false,
        deleting    : false,
        deletingAll : false,
        refreshing  : false,
        loadingMore : false,
    },
    notificationsMeta: {}
}

const getters = {
    notifications: (state) => {
        return state.notifications
    },

    notificationsMeta: (state) => {
        return state.notificationsMeta
    },

    isNotifications: (state)  => {
        return state.isNotifications
    }
}

const actions = {
    async getNotifications( {rootState, commit}, pageNumber ) {
        ( pageNumber == 1 ) 
            ? commit( 'updateFlag', { 'action': 'loading',     'status': true } )
            : commit( 'updateFlag', { 'action': 'loadingMore', 'status': true } )
        
        const { token } = rootState.auth
        const url = 'notifications?page=' + pageNumber

        const response = await api.fetchData( token, url )

        if ( response.status == 200 ) {
            ( pageNumber < 2 )
                ? commit('setNotifications', response.data.data.data)
                : commit('loadMoreNotifications', response.data.data.data)

            commit('setNotificationsMeta', {
                current_page : response.data.data.current_page,
                last_page    : response.data.data.last_page,
                per_page     : response.data.data.per_page,
                to           : response.data.data.to,
                from         : response.data.data.from,
                total        : response.data.data.total,
                total_unread        : response.data.data.total_unread,
            })
        }

        ( pageNumber == 1 )
            ? commit( 'updateFlag', { 'action': 'loading',     'status': false } )
            : commit( 'updateFlag', { 'action': 'loadingMore', 'status': false } )
    },

    async readNotification({rootState, commit}, notificationId) {
        const { token } = rootState.auth
        const response = await api.storeData(token, 'notifications/' + notificationId, "")

        if (response.status == 200){
            response.data = state.notifications.filter(notification => { 
                return notification.id != notificationId 
            })
            
            commit('readNotification', response.data)
        }
    },

    async readAllNotifications({rootState, commit}) {
        const { token } = rootState.auth
        const response = await api.storeData(token, 'notifications', "")

        if (response.status == 200){
            response.data = state.notifications
            
            commit('readNotification', response.data)
        }
    },

    async deleteNotification({rootState, commit}, notificationId) {
        commit('updateFlag', { 'action': 'deleting', 'status': true})

        const { token } = rootState.auth
        const response = await api.deleteData(token, 'notifications', notificationId)

        if (response.status == 200){
            response.data = state.notifications.filter(notification => { 
                return notification.id != notificationId 
            })
            
            commit('deleteNotification', response.data)
        }

        commit('updateFlag', { 'action': 'deleting', 'status': false})
    },

    async deleteAllNotifications({rootState, commit}) {
        commit('updateFlag', { 'action': 'deletingAll', 'status': true})

        const { token } = rootState.auth
        const response = await api.deleteAll(token, 'notifications')

        if (response.status == 200){
            commit('deleteAllNotifications')
        }

        commit('updateFlag', { 'action': 'deletingAll', 'status': false})
    },
}

const mutations = {
    setNotifications: (state, notifications) => {
        state.notifications = notifications
    },

    loadMoreNotifications: (state, notifications) => {
        state.notifications = state.notifications.concat(notifications)
    },

    setNotificationsMeta: (state, metaData) => {
        state.notificationsMeta = metaData
    },

    readNotification: (state, updatedNotifications) => {
        state.notifications = updatedNotifications
    },

    deleteNotification: (state, updatedNotifications) => {
        state.notifications = updatedNotifications
        state.notificationsMeta.total--
    },

    deleteAllNotifications: (state) => {
        state.notifications = []
        state.notificationsMeta.total = 0
    },

    updateFlag: (state, {action, status}) => {
        state.isNotifications[action] = status
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}